import httpClient from './httpClient'
import axios from 'axios'
import { CONFIG_URL } from '@/config/envs.js'

export default {
  async createTranslation({ fromLang, videoId, toLang, additionalConfig }) {
    let requestConfig = {
      type: 'TRANSLATION',
      from_lang: fromLang,
      video_id: videoId,
      to_lang: toLang,
    }
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!additionalConfig) {
      requestConfig = { ...requestConfig, ...additionalConfig }
    }

    const ret = await httpClient.post('/aiworkflow', requestConfig)
    return ret
  },
  async createTranscription({
    fromLang,
    videoId,
    ctx,
    additionalLangs,
    additionalConfig,
  }) {
    let fromLangMethod = fromLang
    if (fromLangMethod === 'pt-br') fromLangMethod = 'pt-BR'
    let requestConfig = {
      type: 'TRANSCRIPTION',
      from_lang: fromLangMethod,
      additional_langs: additionalLangs,
      video_id: videoId,
      ctx,
    }
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!additionalConfig)
      requestConfig = { ...requestConfig, ...additionalConfig }
    const ret = await httpClient.post('/aiworkflow', requestConfig)
    return ret
  },
  async getAiWorkflow(videoId) {
    try {
      const ret = await httpClient.get(
        `/aiworkflow${videoId ? '?video_id=' + videoId : ''}`
      )
      return ret
    } catch (error) {
      return error
    }
  },
  async deleteAiWorkflow(id) {
    const ret = await httpClient.delete(`/aiworkflow/${id}`)
    return ret
  },
  async createDubbing({ fromLang, videoId, voiceId }) {
    const ret = await httpClient.post('/aiworkflow', {
      type: 'DUBBING',
      from_lang: fromLang,
      video_id: videoId,
      background_sound_mode: 'ai',
      voice_id: voiceId,
    })
    return ret
  },
  async createAiWorkFlow({ fromLang, videoId, additionalConfig }) {
    let requestConfig = {
      type: 'ALL_TEXT_ITEMS',
      from_lang: fromLang,
      video_id: videoId,
    }
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!additionalConfig) {
      requestConfig = { ...requestConfig, ...additionalConfig }
    }
    const ret = await httpClient.post('/aiworkflow', requestConfig)
    return ret
  },
  async getAiWorkFlowData(pullzoneName, videoID) {
    try {
      const { data } = await axios.get(
        `${CONFIG_URL}/${pullzoneName}/${videoID}-ai.json?date=${new Date().getTime()}`
      )
      return data
    } catch (error) {
      return error
    }
  },
  async updateAiWorkFlowData(aiData) {
    try {
      const ret = await httpClient.put('/aiworkflow/aipackage', aiData)
      return ret
    } catch (error) {
      return error
    }
  },
  async getDataByFolderId(folderId) {
    try {
      const ret = await httpClient.get(`/aiworkflow?folder_id=${folderId}`)
      return ret
    } catch (error) {
      return error
    }
  },
}
